// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectLoading } from 'redux/slices/loadingSlice';

const ACTIVE_TIME_IN_SECONDS = 30;

export const useCheckUserActivity = (params: {
  timeout?: number;
  onDeActive?: () => void;
  condition?: boolean;
}) => {
  const {
    timeout = ACTIVE_TIME_IN_SECONDS,
    onDeActive,
    condition = true,
  } = params;
  const { isLoading, offlineInitialized } = useSelector(selectLoading);

  const timeRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (!condition) {
      return;
    }

    if (timeRef.current) {
      clearTimeout(timeRef.current);
    }

    timeRef.current = setTimeout(() => {
      onDeActive?.();
    }, timeout * 1000);
  };

  useEffect(() => {
    if (!condition) {
      return;
    }

    const handleActivity = () => {
      resetTimer();
    };

    const events: (keyof WindowEventMap)[] = [
      'keydown',
      'touchstart',
      'touchmove',
      'click',
      'scroll',
      'wheel',
      'pointerdown',
      'focus',
    ];

    events.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    resetTimer();

    return () => {
      if (timeRef.current) {
        clearTimeout(timeRef.current);
      }

      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [timeout, condition, onDeActive]);

  useEffect(() => {
    if (!condition) {
      return;
    }

    if (!isLoading && offlineInitialized) {
      if (!timeRef.current) {
        resetTimer();
      }
    } else if ((isLoading || !offlineInitialized) && timeRef.current) {
      clearTimeout(timeRef.current);
      timeRef.current = null;
    }
  }, [isLoading, offlineInitialized, timeout, condition, onDeActive]);
};
